import { colors } from '@thndr/design-system';
import styled from 'styled-components';
import { Modal as antModal, Button } from 'antd';
import { ModalState } from './Modal';
import { newFonts as fonts, fontsArabic } from '::theme';
interface ModalProps {
  modaState: ModalState;
}
export const Modal = styled(antModal)<ModalProps>`
  .ant-modal-body {
    background: ${(props) =>
      props.modaState == 'Info'
        ? `url('/dots.png'),
      linear-gradient(270deg, #88ff89 -5.27%, #ffff00 106.15%)`
        : '#EEF4EE'};
    padding: auto 0px !important;
  }
  background: ${(props) =>
    props.modaState == 'Info'
      ? `url('/dots.png'),
      linear-gradient(270deg, #88ff89 -5.27%, #ffff00 106.15%)`
      : '#EEF4EE'};
  border-radius: 12px;
  padding: 20px 45px;
  border: 1px solid #1a1a1a;
  box-shadow: 4px 4px 0px #000000;
  @media (max-width: 480px) {
    padding: 20px 0px;
  }
`;

export const ModalButton = styled(Button)<ModalProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 25px 16px !important;
  gap: 4px;
  background: ${(props) => (props.modaState == 'Info' ? '#1a1a1a' : '#F23054')};
  border: ${(props) => (props.modaState == 'Info' ? '1px solid #1a1a1a' : '')};
  border-radius: 40px;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-top: 20px;
  width: 85%;
  cursor: pointer;
  max-width: 360px;
  &:hover,
  &:focus {
    color: ${colors.white} !important;
    border: ${(props) =>
      props.modaState == 'Info' ? '1px solid #1a1a1a' : '1px solid'} !important;
    background: ${(props) =>
      props.modaState == 'Info' ? '#1a1a1a' : '#F23054'}!important;
  }
`;

export const StyledToolTip = styled.img`
  cursor: pointer;
  width: 13px;
  margin-top: ${({ theme }) => (theme.rtl ? '6px' : '')};
  margin-inline-start: 5px;
`;

export const ModalTitle = styled.h3`
  font-weight: 700;
  font-size: 25px;
  line-height: 28px;
  text-align: center;
  color: ${colors.black};
  margin-bottom: 50px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const SubContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
`;

export const Content = styled.div`
  width: 75%;
`;

export const Icon = styled.img`
  object-fit: contain;
  width: 50px;
  margin-inline-end: 10px;
`;

export const Title = styled.h5`
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  margin-bottom: 2px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fonts.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const Price = styled.h4`
  font-weight: 900;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
  display: inline;
  padding-inline-end: 5px;
  font-family: ${({ theme }) =>
    theme.rtl ? fonts.smallRegular.fontFamily : fonts.smallRegular.fontFamily};
`;
export const PriceStrike = styled.h4`
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
  display: block;
  text-decoration: line-through;
  padding-inline-end: 5px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumBold.fontFamily
      : fonts.mediumBold.fontFamily};
`;
export const Period = styled.h4`
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: ${colors.black};
  display: inline-block;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #1a1a1a;
  margin-inline-end: 10px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;
export const Bold = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #1a1a1a;
  margin-inline-end: 5px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumBold.fontFamily
      : fonts.mediumBold.fontFamily};
`;
export const Flex = styled.div`
  align-items: center;
  display: flex;
`;

export const SubscriptionLink = styled.a`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #4683f3;
  margin-inline-end: 3px;
  margin-bottom: 5px;
  &:hover {
    color: #4683f3;
    text-decoration-line: underline;
  }
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumBold.fontFamily
      : fonts.mediumBold.fontFamily};
`;

export const SaveAmount = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #52985b;
  display: inline;
  text-decoration-line: underline;
`;

export const Error = styled.p`
  color: ${colors.red30};
  font-weight: 400;
  font-size: 12px;
  margin-top: 5px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
`;

export const FeatureContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 3px 0px;
`;
export const FeatureText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.2px;
  color: ${colors.black};
  padding: 0px 6px;
  font-family: ${({ theme }) =>
    theme.rtl
      ? fontsArabic.mediumRegular.fontFamily
      : fonts.mediumRegular.fontFamily};
  @media (max-width: 400px) {
    font-size: 14px;
  }
`;
export const ModalText = styled.p`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.2px;
  color: ${colors.black};
  cursor: pointer;
  padding: 0px 6px;
  margin-top: 24px;
  font-family: ${({ theme }) =>
    theme.rtl ? fontsArabic.mediumRegular.fontFamily : 'DM SANS'};
  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

export const CloseIcon = styled.img``;
